module.exports = __webpack_public_path__ + "img/Busbuddy2.b1d4bd11.jpg";